import { FaHeading } from "react-icons/fa";
import { defineType } from "sanity";

export default defineType(
  {
    title: "Hero Image",
    name: "openingHero",
    type: "hero",
    icon: FaHeading
  },
  { aliasFor: "object" }
);
